import { observer } from "mobx-react";
import React, { useContext } from "react";

import { EventContext } from "@gp/components";

import { BetBuilderModeContext } from "@state/context/bet-builder/BetBuilderModeContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { BettingTypeGroup } from "./BettingTypeGroup";

export const BettingTypeGroups = observer(function BettingTypeGroups() {
	const store = useOfferContext<OfferStore.EventViewStore>();
	// @ts-expect-error
	const { id, favoritesBettingTypesIds } = useContext(EventContext);

	if (
		store.displayBettingGroup == "bet-builder" &&
		!store.event?.betBuilder
	) {
		store.setDisplayBettingGroup("all");
	}
	if (
		store.displayBettingGroup === "favorites" &&
		store.favoritesBettingTypeGroups?.[id] &&
		(favoritesBettingTypesIds?.length ?? 0) !== 0
	) {
		// @ts-expect-error
		return store.favoritesBettingTypeGroups[id].map((group) => (
			<BettingTypeGroup key={group.abrv} group={group} isFavorite />
		));
	}

	if (store.displayBettingGroup == "bet-builder") {
		return (
			<BetBuilderModeContext.Provider value={true}>
				{store.betBuilderBettingType.map((group) => (
					<BettingTypeGroup key={group.abrv} group={group} />
				))}
			</BetBuilderModeContext.Provider>
		);
	}
	if (store.displayBettingGroup !== "all") {
		const group = store.bettingTypeGroups.find(
			(g) => g.abrv === store.displayBettingGroup
		);
		if (!group) {
			store.setDisplayBettingGroup("all");
			return null;
		}
		return <BettingTypeGroup key={group.abrv} group={group} />;
	}

	return store.bettingTypeGroups.map((group) => (
		<BettingTypeGroup key={group.abrv} group={group} />
	));
});
